import { Schema, SchemaListUpdate, Table, TablesUpdate } from '@mode/shared/contract-common';

const MAX_NUMBER_OF_PAGES = 2;

export function toSchemaListUpdate(response: any): SchemaListUpdate {
  return {
    currentPage: response?.page ?? 0,
    totalPages: toTotalPages(response),
    count: response?.childCount ?? 0,
    schemas: (response?.children ?? []).map((x: any) => toSchema(x)),
  };
}

function toTotalPages(response: any): number {
  //
  //    DataIndex introduces some new pagination limits
  //
  //    These limits are summarized like this:
  //
  //    1. [Schemas|Tables] will be served in pages of 50
  //    2. At most 2 pages of [schemas|tables] will be served
  //    3. Any [schemas|tables] not accessible through the 2 pages mentioned above
  //        can be fetched using the search component (powered by Algolia)
  //
  //    More details can be found here:
  //
  //      https://docs.google.com/document/d/1RYJrw8_t_wQkvbD0SBSxRmnw8ap8Jh_9reY6u6SEq8Y/edit?pli=1#bookmark=id.591xmzenai0c
  //
  const resultsPerPage = 50;
  const twoPagesOfResults = resultsPerPage * 2;
  const moreThanTwoPagesOfResults = response.childCount >= twoPagesOfResults;

  if (moreThanTwoPagesOfResults) {
    return MAX_NUMBER_OF_PAGES;
  }

  return Math.ceil((response.childCount ?? 0) / resultsPerPage);
}

function toSchema(response: any): Schema {
  return {
    id: response.id,
    name: response.name,
  };
}

export function toTablesUpdate(response: any): TablesUpdate {
  return {
    tables: (response?.children ?? []).map((x: any) => toTable(x, response.name)),
    schemaName: response.name ?? response.id,
    tablesPaginate: {
      page: response?.page ?? 0,
      total: toTotalPages(response),
    },
  };
}

export function toTable(response: any, schemaName: string): Table {
  return {
    columns: (response.children ?? []).map((x: any) => ({ name: x.name, dataType: x.details.columnType })),
    fullName: `${schemaName}.${response.name}`,
    name: response.name ?? response.id,
    objectType: toObjectType(response),
    schema: schemaName,
    objectID: response.id,

    viewCount: 0,
    createdAt: 0,
    updatedAt: 0,
    webPath: '',
    showPath: '',
    accountUsername: '',
    _highlightResult: {},
  };
}

function toObjectType(response: any): string {
  return response.type === 'Table' ? 'data_source_table' : response.type;
}
